/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetLivestockDashboardQueryResponse, GetLivestockDashboardPathParams, GetLivestockDashboardQueryParams, GetLivestockDashboard400, GetLivestockDashboard401, GetLivestockDashboard403, GetLivestockDashboard404, GetLivestockDashboard409, GetLivestockDashboard500 } from "../../types/livestockController/GetLivestockDashboard.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLivestockDashboard } from "../../client/livestockController/getLivestockDashboard.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLivestockDashboardQueryKey = (organizationId: GetLivestockDashboardPathParams["organizationId"] | undefined, params?: GetLivestockDashboardQueryParams) => [{ url: '/api/organizations/:organizationId/livestock-dashboard', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetLivestockDashboardQueryKey = ReturnType<typeof getLivestockDashboardQueryKey>

export function getLivestockDashboardQueryOptions(organizationId: GetLivestockDashboardPathParams["organizationId"] | undefined, params?: GetLivestockDashboardQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLivestockDashboardQueryKey(organizationId, params)
        return queryOptions<GetLivestockDashboardQueryResponse, ResponseErrorConfig<GetLivestockDashboard400 | GetLivestockDashboard401 | GetLivestockDashboard403 | GetLivestockDashboard404 | GetLivestockDashboard409 | GetLivestockDashboard500>, GetLivestockDashboardQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLivestockDashboard(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get livestock dashboard data
 * {@link /api/organizations/:organizationId/livestock-dashboard}
 */
export function useGetLivestockDashboard<TData = GetLivestockDashboardQueryResponse, TQueryData = GetLivestockDashboardQueryResponse, TQueryKey extends QueryKey = GetLivestockDashboardQueryKey>(organizationId: GetLivestockDashboardPathParams["organizationId"] | undefined, params?: GetLivestockDashboardQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetLivestockDashboardQueryResponse, ResponseErrorConfig<GetLivestockDashboard400 | GetLivestockDashboard401 | GetLivestockDashboard403 | GetLivestockDashboard404 | GetLivestockDashboard409 | GetLivestockDashboard500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLivestockDashboardQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getLivestockDashboardQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLivestockDashboard400 | GetLivestockDashboard401 | GetLivestockDashboard403 | GetLivestockDashboard404 | GetLivestockDashboard409 | GetLivestockDashboard500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}